import { render, staticRenderFns } from "./payer-info.vue?vue&type=template&id=65c5a02f"
import script from "./payer-info.vue?vue&type=script&lang=js"
export * from "./payer-info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports